/* theme/assets/fm-money.js — Shopify money formats (spec 2026-10-02 §5.1). Pure. Browser: window.FmMoney; tests: globalThis.FmMoney. */
(function (root) {
  function group(cents, decimals, thousands, decimal) {
    const [int, frac] = (cents / 100).toFixed(decimals).split('.');
    return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
  }
  function format(cents, fmt) {
    const n = Math.round(Number(cents) || 0);
    const f = String(fmt || '${{amount}}').replace(/<[^>]*>/g, '');
    let found = false;
    const out = f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      found = true;
      switch (key) {
        case 'amount_no_decimals': return group(n, 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        case 'amount_with_space_separator': return group(n, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(n, 0, ' ', ',');
        case 'amount_with_period_and_space_separator': return group(n, 2, ' ', '.');
        default: return group(n, 2, ',', '.');
      }
    });
    return found ? out : `${group(n, 2, ',', '.')} ${f}`.trim();
  }
  root.FmMoney = { format };
})(typeof window !== 'undefined' ? window : globalThis);
